import { App as CapacitorApp, AppState } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { useCapacitorListener } from 'hooks/useCapacitorListener';
import { useState, useEffect, useCallback } from 'react';

type UseForegroundStateProps = {
  onlyNative?: boolean;
};

// Allows you to know if the application is "active" (foreground) or not (background)
// on mobile devices. Useful for situations when you want to react to this state change.
export const useForegroundState = (
  props: UseForegroundStateProps = {},
): AppState => {
  const { onlyNative = true } = props;
  // Consider we start on "active" state
  const [appState, setAppState] = useState<AppState>({ isActive: true });

  const getAppState = useCallback(async () => {
    const response = await CapacitorApp.getState();
    setAppState(response);
  }, []);

  useCapacitorListener('appStateChange', setAppState, {
    enabled: !onlyNative || Capacitor.isNativePlatform(),
  });

  // Get app state as soon as this component mounts
  useEffect(() => {
    getAppState();
  }, [getAppState]);

  return appState;
};
